var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hideFoot)?_c('div'):_c('div',{staticClass:"footInfo"},[_c('p',[_vm._v(_vm._s(_vm.footInfo))]),_c('p',[_vm._v(_vm._s(_vm.footInfo1))])])
}
var staticRenderFns = []

export { render, staticRenderFns }